import { BaseResource } from 'utils/ApiUtils';

export default class IdrResource extends BaseResource {
    constructor(args) {
      super(args, IdrResource.attributes);
    };
  
    static columns = [
      { title: "Resource Name", field: "Name_SystemUser" },
      { title: "Email Address", field: "QcReqYn" },
      { title: "Select", field: "QcReqYn" }
    ]
  
    static expand = [{ 'SystemUser': { select: ['Name', 'InspectorNumber'] } }]
  
  
    static attributes = IdrResource.columns.map(r => r.field);

};